export default __webpack_public_path__ + "915b9f1f47e6799936394116b81d282c.png";